// extracted by mini-css-extract-plugin
module.exports = {"no-chats":"RequestedChatList_no-chats__3AxuR","chat-list":"RequestedChatList_chat-list__19_Oo"};